import React from 'react';
import { PipelineItem, PipelineStatus, PipelineStep } from '../../../const/PipelineTypes';
import { deduplicateSteps, getStageStatus } from '../PipelineUtils';
import StageToolTipIcon from './StageToolTipIcon';
import styles from '../PipelineDetail.module.css';

interface StagesSideMenuProps {
  environmentGroups: Record<string, string[]>;
  stages: Record<string, PipelineStep[]>;
  pipeline: PipelineItem;
  expandedStages: Record<string, boolean>;
  selectedStage: string;
  selectedStep: string;
  theme: boolean;
  onToggleStage: (stageName: string) => void;
  onStepClick: (stageName: string, step: PipelineStep) => void;
}

const StagesSideMenu: React.FC<StagesSideMenuProps> = ({
  environmentGroups, stages, pipeline, expandedStages, selectedStage, selectedStep, theme, onToggleStage, onStepClick,
}) => {
  return (
    <div className={styles.menuPanel}>
      {Object.entries(environmentGroups).map(([envName, envStages]) => {
        if (envStages.length === 0) return null;
        return (
          <div key={envName} className={styles.menuEnvironment}>
            <div className={styles.menuEnvironmentHeader}>{envName}</div>
            {envStages.map((stageName) => {
              const steps = stages[stageName];
              const status = getStageStatus(stageName, pipeline);
              const isExpanded = !!expandedStages[stageName];
              return (
                <div key={stageName} className={styles.menuStage}>
                  <div className={styles.menuStageHeader} onClick={() => onToggleStage(stageName)}>
                    <span>
                      <i className={`icon ${isExpanded ? 'icon-chevron-down' : 'icon-chevron-right'} ${styles.menuChevron}`} />
                    </span>
                    <StageToolTipIcon status={status} theme={theme} />
                    <span>{stageName}</span>
                  </div>
                  {isExpanded && steps?.length > 0 && deduplicateSteps(steps).map((step) => {
                    const isSelected = selectedStage === stageName && selectedStep === step.Step;
                    const stepClass = [styles.menuStep, isSelected ? styles.menuStepSelected : ''].join(' ');
                    return (
                      <div
                        key={step.Step}
                        className={stepClass}
                        onClick={() => onStepClick(stageName, step)}
                      >
                        <StageToolTipIcon status={step.Status.toLowerCase() as PipelineStatus} theme={theme} />
                        <span className={styles.truncateText}>{step.Step}</span>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default StagesSideMenu;
